export default "__VITE_ASSET__DLuSH53D__";